import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enOrders from '../locales/en/orders.json';
import enInventory from '../locales/en/inventory.json';
import enDashboard from '../locales/en/dashboard.json';
import enValidation from '../locales/en/validation.json';
import enNavigation from '../locales/en/navigation.json';
import enProfile from '../locales/en/profile.json';
import enAdmin from '../locales/en/admin.json';
import enAccount from '../locales/en/account.json';
import enErrors from '../locales/en/errors.json';
import enForms from '../locales/en/forms.json';
import enSubscription from '../locales/en/subscription.json';
import enReceivables from '../locales/en/receivables.json';

import hiCommon from '../locales/hi/common.json';
import hiAuth from '../locales/hi/auth.json';
import hiOrders from '../locales/hi/orders.json';
import hiInventory from '../locales/hi/inventory.json';
import hiDashboard from '../locales/hi/dashboard.json';
import hiValidation from '../locales/hi/validation.json';
import hiNavigation from '../locales/hi/navigation.json';
import hiProfile from '../locales/hi/profile.json';
import hiAdmin from '../locales/hi/admin.json';
import hiAccount from '../locales/hi/account.json';
import hiErrors from '../locales/hi/errors.json';
import hiForms from '../locales/hi/forms.json';
import hiSubscription from '../locales/hi/subscription.json';
import hiReceivables from '../locales/hi/receivables.json';

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    orders: enOrders,
    inventory: enInventory,
    dashboard: enDashboard,
    validation: enValidation,
    navigation: enNavigation,
    profile: enProfile,
    admin: enAdmin,
    account: enAccount,
    errors: enErrors,
    forms: enForms,
    subscription: enSubscription,
    receivables: enReceivables,
  },
  hi: {
    common: hiCommon,
    auth: hiAuth,
    orders: hiOrders,
    inventory: hiInventory,
    dashboard: hiDashboard,
    validation: hiValidation,
    navigation: hiNavigation,
    profile: hiProfile,
    admin: hiAdmin,
    account: hiAccount,
    errors: hiErrors,
    forms: hiForms,
    subscription: hiSubscription,
    receivables: hiReceivables,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Add fallback to prevent nativeName errors
      checkWhitelist: true,
    },
    
    // Supported languages
    supportedLngs: ['en', 'hi'],
    
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already does escaping
      prefix: '{', // Use single braces {variable} instead of default {{variable}}
      suffix: '}',
    },
    
    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'auth', 'orders', 'inventory', 'dashboard', 'validation', 'navigation', 'profile', 'admin', 'account', 'errors', 'forms', 'subscription', 'receivables'],
    
    // React i18next options
    react: {
      useSuspense: false, // Disable suspense for better compatibility
    },
    
    // Ensure i18n is ready before components render
    initImmediate: false,
  })
  .then(() => {
    // Set HTML lang attribute for CSS targeting on initial load
    document.documentElement.setAttribute('lang', i18n.language);
  })
  .catch((error) => {
    // i18n initialization failed - handled silently
  });

export default i18n;
